import { useEffect } from 'react'
import { applyLanguage, useUserProfileQuery } from '@/hooks/useUserProfile'

/**
 * Applies the signed-in user's saved UI language on load (TO-197 REQ-010): a
 * chosen language becomes the active react-i18next language and the device's
 * stored choice. `null` ("automatic") leaves the resolved language alone.
 */
export function useLanguagePreference(): void {
	const { data } = useUserProfileQuery()
	const language = data?.language ?? null
	useEffect(() => {
		if (language !== null) void applyLanguage(language)
	}, [language])
}
